import React, { useEffect, useRef, useState } from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Flex, Skeleton, UiText } from '@shared/ui';
import { getEstimateInformationQuery } from '@widgets/EstimateInformation/api/hooks/getEstimateInformationQuery';
import { EstimateStatus } from '@widgets/EstimateInformation/ui/EstimateStatus';
import { InfoItem } from '@widgets/EstimateInformation/ui/InfoItem';

import cls from './EstimateMainInfo.module.css';

export const EstimateMainInfo = () => {
    const { data, isPending } = getEstimateInformationQuery();
    const { t } = useTranslation();

    const addressRef = useRef<HTMLSpanElement | null>(null);
    const [isAddressTruncated, setIsAddressTruncated] = useState(false);

    const checkTruncate = () => {
        const el = addressRef.current;
        if (!el) return;
        setIsAddressTruncated(el.scrollWidth > el.clientWidth);
    };

    useEffect(() => {
        checkTruncate();
    }, [checkTruncate, data?.address, isPending]);

    useEffect(() => {
        const el = addressRef.current;
        if (!el) return;

        const ro = new ResizeObserver(() => checkTruncate());
        ro.observe(el);

        return () => ro.disconnect();
    }, [checkTruncate]);

    return (
        <Flex direction="column" align="start" gap={8}>
            <InfoItem label={t('EstimateMainInfo.return.Flex.InfoItem.label.object')}>
                {isPending ? (
                    <Skeleton width={168} height={28} border="8px" />
                ) : (
                    <a href={data?.project?.url}>{data?.project?.name}</a>
                )}
            </InfoItem>

            <InfoItem label={t('EstimateMainInfo.return.Flex.InfoItem.label.address')}>
                {isPending ? (
                    <Skeleton width={159} height={28} border="8px" />
                ) : (
                    <UiText
                        classes={cn(cls.addressText, !data?.address && cls.addressPlaceHolder)}
                        variant="mediumPlain"
                        ref={addressRef}
                        title={isAddressTruncated ? data?.address ?? '' : undefined}
                    >
                        {data?.address
                            ? data?.address
                            : t('EstimateMainInfo.return.Flex.InfoItem.label.address.placeholder')}
                    </UiText>
                )}
            </InfoItem>

            <EstimateStatus />
        </Flex>
    );
};
